// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3IqVH","title":"Info_title__3yccr","selects":"Info_selects__Mti9k","requiredAsterisk":"Info_requiredAsterisk__1AVEl"};